
define(
	'Tavano.TavanoteamGA4.TTGA4.Utils'
,   [
        'underscore'
	]
,   function (
        _
	)
{
	'use strict';
    var isMinVersion = isBundleMinVersion();
    function getApplication(ctx)
    {
        return _.isFunction(SC.Application) ? SC.Application(ctx) : SC.Application;
    }
    function getDataLayer()
    {
        return window.dataLayer || [];
    }
    function pushToDataLayer(data)
    {
        var tracker = getDataLayer();
        tracker.push(data);
    }
    function isBundleMinVersion()
    {
        var scVersion = SC.ENVIRONMENT.RELEASE_METADATA.version.split('.')
        ,	scVersionYear = new Date(scVersion[0]).getFullYear()
        ,	scVersionRelease = parseInt(scVersion[1])
        ,	isMinVersion = false;
        //minimum version supported by the addTracker extensibility
        //is 2021.1. We have to check the SC or SCA version in order to identify
        //if the extensibility is usable
        if(scVersionYear >= 2021 && scVersionRelease >= 1)
        {
            isMinVersion = true;
        }
        return isMinVersion;
    }
    // function addEventTrackerGA4(eventTrackerName, eventCallback)
    // {
    //     var env = SC.Application.getComponent('Environment')
    //     ,   eventTrackerObj = {};
    //     if(!eventTrackerObj.hasOwnProperty(eventTrackerName))
    //     {
    //         if(eventCallback && _.isFunction(eventCallback))
    //         {
    //             eventTrackerObj[eventTrackerName] = eventCallback;
    //         }
    //         else
    //         {
    //             eventTrackerObj[eventTrackerName] = function(data)
    //             {
    //                 pushToDataLayer(data);
    //             }
    //         }
    //     }
    //     console.log("eventTrackerObj", eventTrackerObj)
    //     env.addTracker(eventTrackerObj);
    // }
    function trackPageViewGA4(pageUrl, container, pagesource)
    {
        console.log("pagesource", pagesource);
        if(pagesource == 'checkout')
        {
            console.log("!window.isPageViewed", !window.isPageViewed)
            if(!window.isPageViewed)
            {
                pushToDataLayer({
                    event: 'TT_page_view'
                ,   data: {
                        page: pageUrl
                    }
                });
            }
            window.isPageViewed = true;
        }
        else
        {
            pushToDataLayer({
                event: 'TT_page_view'
            ,   data: {
                    page: pageUrl
                }
            });
        }
    }
    function trackLoginGA4(container, userid)
    {
        var eventData = {
                event: "TT_login"
            ,   data: {
                    method: "Web"
                ,   client_id: userid
                }
            };
        pushToDataLayer(eventData);
    }
    function trackRegisterGA4(container)
    {
        var eventData = {
                event: "TT_sign_up"
            ,   data: {
                    method: "Web"
                }
            };
        pushToDataLayer(eventData);
    }
    function trackProductViewGA4(itemData, container)
    {
        var eventData = {
                event: 'TT_view_item'
            ,   data: itemData
            };
        pushToDataLayer(eventData);
    }
    function trackCartViewGA4(cartData, container)
    {
        var eventData = {
            event: 'TT_view_cart'
        ,   data: {
                currency: cartData.currency
            ,   items_cart: cartData.items
            ,   value: cartData.value   
            }
        };
        pushToDataLayer(eventData);
    }
    function trackAddToCartGA4(cartData, container)
    {
        pushToDataLayer({
            event: "TT_add_to_cart"
        ,   data: cartData
        });
    }
    function trackRemoveItemCartGA4(removedItemData, container)
    {
        var eventData = {
                event: 'TT_remove_from_cart'
            ,   data: removedItemData
            };
        // if(isMinVersion)
        // {
        //     var env = container.getComponent('Environment');
        //     addEventTrackerGA4('trackerRemoveItemInCart');
        //     env.triggerEvent('trackerRemoveItemInCart', eventData);
        // }
        // else
        // {
            pushToDataLayer(eventData);
        //}
    }
    function trackSearchGA4(query, method, container)	
    {	
        var eventData = {	
            event: 'TT_search'	
        ,   data: {	
                search_term: query	
            ,   search_method: method	
            }
        };
        // if(isMinVersion)
        // {
        //     var env = container.getComponent('Environment');
        //     addEventTrackerGA4('trackSearchEvent', function(data)
        //     {
        //         pushToDataLayer(data);
        //     });
        //     env.triggerEvent('trackSearchEvent', eventData);
        // }
        // else
        // {
            pushToDataLayer(eventData);
        // }
    }
    function trackAddToWishlistGA4(itemData, container)
    {
        pushToDataLayer({
            event: 'TT_add_to_wishlist'
        ,   data: itemData
        });
    }
    function trackBeginCheckoutGA4(eventData, container)
    {
        console.log("eventData checkout", eventData);
        
        pushToDataLayer({
            event: 'TT_begin_checkout'
        ,   data: eventData
        });
    }
    function trackShipInfoGA4(eventData, container)	
    {	
        if(!window.isShipInfoAdded)	
        {	
            pushToDataLayer({	
                event: 'TT_add_shipping_info'	
            ,   data: eventData	
            });	
            window.isShipInfoAdded = true;	
        }	
        window.isProfileLoaded = true;	
    }	
    function trackPaymentInfoGA4(eventData, container)	
    {	
        if(!window.isPaymentAdded)	
        {	
            pushToDataLayer({	
                event: 'TT_add_payment_info'	
            ,   data: eventData	
            });	
            window.isPaymentAdded = true;	
        }	
    }
    function trackPurchaseGA4(eventData, container)
    {
        pushToDataLayer({
            event: 'TT_purchase'
        ,   data: eventData
        });
    }
    function trackProductSelectGA4(eventData, container)
    {
        pushToDataLayer({
            event: "TT_select_item"
        ,   data: eventData
        });
    }
    function trackProductListGA4(eventData, container)
    {
        pushToDataLayer({
            event: "TT_view_item_list"
        ,   data: eventData
        })
    }
    function trackGenerateLead(eventData, container)
    {
        pushToDataLayer({
            event: "TT_generate_lead"
        ,   data: eventData
        });
    }
    function getCookieByName(name)
    {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        //returns null if there is no match
        if(match)
        {
            return match[2];
        }
        return match;
    }
    function trackCheckoutAsGuestGA4()
    {
        var eventData = {
            event: "TT_guest_checkout"
        ,   data: {
                method: "Web"
            }
        };
        pushToDataLayer(eventData);
    }
	var TTGA4Utils = {
        trackPageViewGA4: trackPageViewGA4
    ,   trackLoginGA4: trackLoginGA4
    ,   trackRegisterGA4: trackRegisterGA4
    ,   trackProductViewGA4: trackProductViewGA4
    ,   trackCartViewGA4: trackCartViewGA4
    ,   trackAddToCartGA4: trackAddToCartGA4
    ,   trackRemoveItemCartGA4: trackRemoveItemCartGA4
    ,   trackSearchGA4: trackSearchGA4
    ,   trackAddToWishlistGA4: trackAddToWishlistGA4
    ,   trackBeginCheckoutGA4: trackBeginCheckoutGA4
    ,   trackShipInfoGA4: trackShipInfoGA4
    ,   trackPaymentInfoGA4: trackPaymentInfoGA4
    ,   trackPurchaseGA4: trackPurchaseGA4
    ,   trackProductSelectGA4: trackProductSelectGA4
    ,   trackProductListGA4: trackProductListGA4
    ,   trackGenerateLead: trackGenerateLead
    ,   trackCheckoutAsGuestGA4: trackCheckoutAsGuestGA4
    ,   isBundleMinVersion: isBundleMinVersion
    ,   getApplication: getApplication
    ,   getCookieByName: getCookieByName
    };
    // _.mixin(TTGA4Utils);
    return TTGA4Utils;
});
